import { TAG_COLOR_NAMES, tagColor } from "@/lib/tag-styles"
import { TAG_ICON_NAMES, tagIcon } from "@/lib/tag-icons"
import { cn } from "@/lib/utils"

// Grid of color swatches. The active color gets a ring. Mirrors the channel
// ColorPicker so the two stay visually consistent.
export function TagColorPicker({
  value,
  onChange,
}: {
  value: string
  onChange: (next: string) => void
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {TAG_COLOR_NAMES.map((name) => {
        const color = tagColor(name)
        const active = value === name
        return (
          <button
            key={name}
            type="button"
            aria-label={name}
            aria-pressed={active}
            onClick={() => onChange(name)}
            className={cn(
              "h-7 w-7 cursor-pointer rounded-full border transition-all",
              color.swatch,
              active
                ? "border-ink-display ring-2 ring-offset-2 ring-offset-page ring-ink-display"
                : "border-hairline hover:scale-110",
            )}
          />
        )
      })}
    </div>
  )
}

// Grid of icon buttons. The active icon is filled with the accent surface.
export function TagIconPicker({
  value,
  onChange,
}: {
  value: string
  onChange: (next: string) => void
}) {
  return (
    <div className="grid grid-cols-8 gap-1.5">
      {TAG_ICON_NAMES.map((name) => {
        const Icon = tagIcon(name)
        const active = value === name
        return (
          <button
            key={name}
            type="button"
            aria-label={name}
            aria-pressed={active}
            onClick={() => onChange(name)}
            className={cn(
              "inline-flex h-8 w-8 items-center justify-center rounded-md border transition-colors",
              active
                ? "border-accent bg-accent-faded text-accent-display"
                : "border-hairline text-ink-body hover:bg-surface hover:text-ink-display",
            )}
          >
            <Icon className="h-4 w-4" />
          </button>
        )
      })}
    </div>
  )
}
